export const UPDATE_NOTIFICATION_FOR_FEATURE = "UPDATE_NOTIFICATION_FOR_FEATURE"
